import { createSlice } from "@reduxjs/toolkit";
import {  httpGet, httpPost } from "../../../util/Rest";
import { REVIEW_STATUS } from "../../../constants/Lookup";

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  getNotesData: [],
  isEligibleNotesStatus: null,
  eligibleScrubAllData: [],
  isEligibleNotesLoading: false,
  dropDownData: {},
};

const slice = createSlice({
  name: "eligibleScrub",
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchStartNotes: (state) => {
      state.isEligibleNotesLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    getEligibleNotesData: (state, action) => {
      state.getNotesData = action.payload;
      state.isLoading = false;
    },
    postEligibleScrub: (state, action) => {
      state.isEligibleNotesStatus = action?.payload?.status;
      state.isEligibleNotesLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isEligibleNotesLoading = false;
      state.isEligibleNotesStatus = null;
    },
    resetStatus: (state) => {
      state.isEligibleNotesStatus = null;
      state.errorMsg = null;
    },
    getEligibleScrubData: (state, action) => {
      state.eligibleScrubAllData = action.payload;
      state.isPreprocessorLoading = false;
      state.preProcessorErrorMsg = null;
      state.preProcessorSuccessMsg = null;
    },
    resetEligibleScrubData: (state, action) => {
      state.eligibleScrubAllData = [];
    },
    resetNotesData: (state, action) => {
      state.getNotesData = [];
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  fetchError,
  getEligibleNotesData,
  postEligibleScrub,
  resetMsg,
  resetStatus,
  getEligibleScrubData,
  resetEligibleScrubData,
  fetchDropDownData,
  fetchStartNotes,
  resetNotesData,
} = slice.actions;

export const getEligibleScrubNotes = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`pronto/find/eligibilityreview/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getEligibleNotesData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postEligibleScrubData = (details) => {
  return (dispatch) => {
    dispatch(fetchStartNotes());
    httpPost(`pronto/eligibility/review/save`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postEligibleScrub(data));
        } else {
          dispatch(fetchError(data?.data?.error ? data?.data?.error : data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchEligibleScrubAllData = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`pronto/find/eligiblesummary/${accountNumber}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getEligibleScrubData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [REVIEW_STATUS],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const eligibleScrubNotesReset = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetPostStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const resetEligibleScrub =()=>{
  return (dispatch)=>{
    dispatch(resetEligibleScrubData())
  }
}
export const resetEligibleNotesTableData = () => {
  return (dispatch) => {
    dispatch(resetNotesData());
  };
};

